import React, { useState } from 'react';
import { Sidebar } from './sidebar';
import { Header } from './header';
import { PageContainer } from './page-container';
import { AuthGuard } from '@/components/guards/auth-guard';
import { cn } from '@/lib/utils';

interface DashboardLayoutProps {
    children: React.ReactNode;
    isDashboard?: boolean;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children, isDashboard = false }) => {
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

    return (
        <AuthGuard>
            <div className="relative flex h-screen overflow-hidden bg-background">
                <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-card focus:px-4 focus:py-2 focus:shadow-raised">
                    Skip to content
                </a>

                {/* Desktop sidebar reserves its width in the flex row */}
                <div className="hidden lg:flex lg:shrink-0">
                    <Sidebar variant="desktop" />
                </div>

                {/* Mobile drawer */}
                <div
                    className={cn(
                        'fixed inset-0 z-30 bg-[hsl(222_47%_9%/0.45)] backdrop-blur-[2px] transition-opacity duration-300 lg:hidden',
                        isMobileSidebarOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
                    )}
                    onClick={() => setIsMobileSidebarOpen(false)}
                    aria-hidden
                />
                <div className="lg:hidden">
                    <Sidebar
                        variant="mobile"
                        isMobileOpen={isMobileSidebarOpen}
                        onMobileClose={() => setIsMobileSidebarOpen(false)}
                    />
                </div>

                <div className="flex w-full min-w-0 flex-1 flex-col overflow-hidden">
                    <Header onMenuClick={() => setIsMobileSidebarOpen(true)} />
                    <PageContainer isDashboard={isDashboard}>{children}</PageContainer>
                </div>
            </div>
        </AuthGuard>
    );
};
